// extracted by mini-css-extract-plugin
export default {"footer-container":"Footer_footer-container__URp4q","footer-text-container":"Footer_footer-text-container__OQBBq"};